<!-- eslint-disable vue/require-toggle-inside-transition -->
<!-- eslint-disable vuejs-accessibility/click-events-have-key-events -->
<!-- eslint-disable vuejs-accessibility/no-static-element-interactions -->
<template>
  <Teleport
    v-if="localShow"
    to="body"
  >
    <div
      v-bind="$attrs"
      style="position: absolute; z-index: 1040;"
    >
      <Transition name="fade">
        <div
          ref="modal"
          class="modal chimp-scroll"
          :class="modalStyles"
          role="dialog"
          aria-modal="true"
          style="display: block;"
          @click="closeClick"
        >
          <div
            class="modal-dialog"
            :class="dialogClasses"
          >
            <span tabindex="0" />
            <div
              :id="localId"
              ref="content"
              class="modal-content"
              tabindex="-1"
            >
              <header
                v-if="!hideHeader"
                class="modal-header"
                :class="headerClasses"
              >
                <slot name="modal-header">
                  <h5
                    class="modal-title"
                    :class="titleClasses"
                  >
                    <slot name="modal-title">
                      {{ title }}
                    </slot>
                  </h5>
                  <button
                    type="button"
                    class="close"
                    aria-label="Close"
                    @click="close"
                    @keypress="close"
                  >
                    ×
                  </button>
                </slot>
              </header>
              <div
                class="modal-body"
                :class="bodyClasses"
              >
                <slot />
              </div>
              <footer
                v-if="!hideFooter"
                class="modal-footer"
                :class="footerClasses"
              >
                <slot name="modal-footer">
                  <BButton
                    v-if="!okOnly"
                    :variant="cancelVariant"
                    @click="onCancel"
                  >
                    {{ cancelTitle }}
                  </BButton>
                  <BButton
                    variant="primary"
                    :disabled="okDisabled"
                    @click="onOk"
                  >
                    {{ okTitle }}
                  </BButton>
                </slot>
              </footer>
            </div>
          </div>
          <span tabindex="0" />
        </div>
      </Transition>
      <Transition name="fade">
        <div
          class="modal-backdrop"
          @click="close"
        />
      </Transition>
    </div>
  </Teleport>
</template>

<script>
import BButton from './BButton.vue'
const BUTTON_CANCEL = 'cancel'
const BUTTON_CLOSE = 'headerclose'
const BUTTON_OK = 'ok'
const getBCR = el => el?.getBoundingClientRect() || null
const stringProp = (def = '') => ({ type: String, default: def })

export default {
  name: 'BModal',
  components: {
    BButton
  },
  inheritAttrs: false,
  props: {
    bodyBgVariant: stringProp(),
    bodyClass: stringProp(),
    bodyTextVariant: stringProp(),
    cancelDisabled: Boolean,
    cancelTitle: stringProp('cancel'),
    cancelVariant: stringProp('secondary'),
    centered: Boolean,
    dialogClass: stringProp(),
    footerBgVariant: stringProp(),
    footerBorderVariant: stringProp(),
    footerClass: stringProp(),
    footerTextVariant: stringProp(),
    headerBgVariant: stringProp(),
    headerBorderVariant: stringProp(),
    headerClass: stringProp(),
    headerTextVariant: stringProp(),
    hideFooter: Boolean,
    hideHeader: Boolean,
    lazy: Boolean,
    modelValue: {
      type: Boolean,
      default: undefined
    },
    noCloseOnBackdrop: Boolean,
    noCloseOnEsc: Boolean,
    noFade: Boolean,
    okDisabled: Boolean,
    okOnly: Boolean,
    okTitle: stringProp('OK'),
    okVariant: stringProp('primary'),
    scrollable: Boolean,
    size: stringProp('md'),
    title: stringProp(),
    titleClass: stringProp(),
    titleSrOnly: Boolean,
    visible: {
      type: Boolean,
      default: undefined
    }
  },
  emits: ['hide', 'update:modelValue', 'show', 'shown', 'ok', 'cancel', 'close', 'hide', 'hidden'],
  data() {
    return {
      localShow: '',
      isBodyOverflowing: false,
      isModalOverflowing: false,
      isBlock: false,
      localId: '',
      scrollbarWidth: 0
    }
  },
  computed: {
    modalClasses() {
      return [
        {
          fade: !this.noFade
        },
        this.modalClass
      ]
    },
    modalStyles() {
      const sbWidth = `${this.scrollbarWidth}px`
      return {
        paddingLeft: !this.isBodyOverflowing && this.isModalOverflowing ? sbWidth : '',
        paddingRight: this.isBodyOverflowing && !this.isModalOverflowing ? sbWidth : '',
        display: this.isBlock ? 'block' : 'none'
      }
    },
    dialogClasses() {
      return [
        {
          [`modal-${this.size}`]: this.size,
          'modal-dialog-centered': this.centered,
          'modal-dialog-scrollable': this.scrollable
        },
        this.dialogClass
      ]
    },
    headerClasses() {
      return [
        {
          [`bg-${this.headerBgVariant}`]: this.headerBgVariant,
          [`text-${this.headerTextVariant}`]: this.headerTextVariant,
          [`border-${this.headerBorderVariant}`]: this.headerBorderVariant
        },
        this.headerClass
      ]
    },
    titleClasses() {
      return [{ 'sr-only': this.titleSrOnly }, this.titleClass]
    },
    bodyClasses() {
      return [
        {
          [`bg-${this.bodyBgVariant}`]: this.bodyBgVariant,
          [`text-${this.bodyTextVariant}`]: this.bodyTextVariant
        },
        this.bodyClass
      ]
    },
    footerClasses() {
      return [
        {
          [`bg-${this.footerBgVariant}`]: this.footerBgVariant,
          [`text-${this.footerTextVariant}`]: this.footerTextVariant,
          [`border-${this.footerBorderVariant}`]: this.footerBorderVariant
        },
        this.footerClass
      ]
    }
  },
  watch: {
    modelValue: {
      immediate: true,
      handler(val) {
        if (val !== undefined) {
          this.toggle(val)
        }
      }
    },
    visible: {
      immediate: true,
      handler(val) {
        if (val !== undefined) {
          this.toggle(val || this.modelValue)
        }
      }
    }
  },
  mounted() {
    this.localId = `_BV_modal_${this.$uuid}`
  },
  methods: {
    toggle(state) {
      if (state && !this.localShow) {
        document.body.classList.add('modal-open')
        this.$emit('show')
        this.show()
      } else {
        if (this.localShow) {
          document.body.classList.remove('modal-open')
          this.$emit('hide')
          this.hide()
        }
      }
    },
    setListeners() {
      document.addEventListener('keydown', this.escToClose)
    },
    removeListeners() {
      document.removeEventListener('keydown', this.escToClose)
    },
    close(trigger = '') {
      this.$emit('update:modelValue', false)
      if (trigger === BUTTON_OK) {
        this.$emit('ok')
      } else if (trigger === BUTTON_CANCEL) {
        this.$emit('cancel')
      } else if (trigger === BUTTON_CLOSE) {
        this.$emit('close')
      }
      this.$emit('hide')
      this.hide()
    },
    escToClose(e) {
      if (e.keyCode === 27 && this.localShow && !this.noCloseOnEsc) {
        this.$emit('hide')
        this.hide()
      }

      if (this.localShow) {
      }
    },
    onOk() {
      this.close(BUTTON_OK)
    },
    onCancel() {
      this.close(BUTTON_CANCEL)
    },
    onClose() {
      this.close(BUTTON_CLOSE)
    },
    closeClick(event) {
      const modalContent = this.$refs.content
      if (this.localShow && !this.noCloseOnBackdrop && modalContent && !modalContent.contains(event.target) && document.body.contains(event.target)) {
        this.close()
      }
    },
    checkModalOverflow() {
      if (this.isVisible) {
        const modal = this.$refs.modal
        this.isModalOverflowing = modal.scrollHeight > document.documentElement.clientHeight
      }
    },
    checkScrollbar() {
      // Determine if the body element is overflowing
      const { left, right } = getBCR(document.body)
      this.isBodyOverflowing = left + right < window.innerWidth
    },
    show() {
      if (this.localShow) {
        return
      }
      this.localShow = true
      this.$emit('update:modelValue', true)
      this.$nextTick(() => {
        this.checkScrollbar()
        this.checkModalOverflow()
        this.setListeners()
        this.$emit('shown')
      })
    },
    hide() {
      if (!this.localShow) {
        return
      }
      this.localShow = false
      this.$emit('update:modelValue', false)
      this.$nextTick(() => {
        this.removeListeners()
        this.$emit('hidden')
      })
    }
  }
}
</script>
